import { StatusPair } from '../models/status-pair';

export class PhoneCodeData {
    private codes: Array<StatusPair> = [
        new StatusPair('DZ', '213'),
        new StatusPair('AD', '376'),
        new StatusPair('AO', '244'),
        new StatusPair('AI', '1264'),
        new StatusPair('AG', '1268'),
        new StatusPair('AR', '54'),
        new StatusPair('AM', '374'),
        new StatusPair('AW', '297'),
        new StatusPair('AU', '61'),
        new StatusPair('AT', '43'),
        new StatusPair('AZ', '994'),
        new StatusPair('BS', '1242'),
        new StatusPair('BH', '973'),
        new StatusPair('BD', '880'),
        new StatusPair('BB', '1246'),
        new StatusPair('BY', '375'),
        new StatusPair('BE', '32'),
        new StatusPair('BZ', '501'),
        new StatusPair('BJ', '229'),
        new StatusPair('BM', '1441'),
        new StatusPair('BT', '975'),
        new StatusPair('BO', '591'),
        new StatusPair('BA', '387'),
        new StatusPair('BW', '267'),
        new StatusPair('BR', '55'),
        new StatusPair('BN', '673'),
        new StatusPair('BG', '359'),
        new StatusPair('BF', '226'),
        new StatusPair('BI', '257'),
        new StatusPair('KH', '855'),
        new StatusPair('CM', '237'),
        new StatusPair('CA', '1'),
        new StatusPair('CV', '238'),
        new StatusPair('KY', '1345'),
        new StatusPair('CF', '236'),
        new StatusPair('CL', '56'),
        new StatusPair('CN', '86'),
        new StatusPair('CO', '57'),
        new StatusPair('KM', '269'),
        new StatusPair('CG', '242'),
        new StatusPair('CK', '682'),
        new StatusPair('CR', '506'),
        new StatusPair('HR', '385'),
        new StatusPair('CU', '53'),
        new StatusPair('CY', '90392'),
        new StatusPair('CY', '357'),
        new StatusPair('CZ', '42'),
        new StatusPair('DK', '45'),
        new StatusPair('DJ', '253'),
        new StatusPair('DM', '1809'),
        new StatusPair('DO', '1809'),
        new StatusPair('EC', '593'),
        new StatusPair('EG', '20'),
        new StatusPair('SV', '503'),
        new StatusPair('GQ', '240'),
        new StatusPair('ER', '291'),
        new StatusPair('EE', '372'),
        new StatusPair('ET', '251'),
        new StatusPair('FK', '500'),
        new StatusPair('FO', '298'),
        new StatusPair('FJ', '679'),
        new StatusPair('FI', '358'),
        new StatusPair('FR', '33'),
        new StatusPair('GF', '594'),
        new StatusPair('PF', '689'),
        new StatusPair('GA', '241'),
        new StatusPair('GM', '220'),
        new StatusPair('GE', '7880'),
        new StatusPair('DE', '49'),
        new StatusPair('GH', '233'),
        new StatusPair('GI', '350'),
        new StatusPair('GR', '30'),
        new StatusPair('GL', '299'),
        new StatusPair('GD', '1473'),
        new StatusPair('GP', '590'),
        new StatusPair('GU', '671'),
        new StatusPair('GT', '502'),
        new StatusPair('GN', '224'),
        new StatusPair('GW', '245'),
        new StatusPair('GY', '592'),
        new StatusPair('HT', '509'),
        new StatusPair('HN', '504'),
        new StatusPair('HK', '852'),
        new StatusPair('HU', '36'),
        new StatusPair('IS', '354'),
        new StatusPair('IN', '91'),
        new StatusPair('ID', '62'),
        new StatusPair('IR', '98'),
        new StatusPair('IQ', '964'),
        new StatusPair('IE', '353'),
        new StatusPair('IL', '972'),
        new StatusPair('IT', '39'),
        new StatusPair('JM', '1876'),
        new StatusPair('JP', '81'),
        new StatusPair('JO', '962'),
        new StatusPair('KZ', '7'),
        new StatusPair('KE', '254'),
        new StatusPair('KI', '686'),
        new StatusPair('KP', '850'),
        new StatusPair('KR', '82'),
        new StatusPair('KW', '965'),
        new StatusPair('KG', '996'),
        new StatusPair('LA', '856'),
        new StatusPair('LV', '371'),
        new StatusPair('LB', '961'),
        new StatusPair('LS', '266'),
        new StatusPair('LR', '231'),
        new StatusPair('LY', '218'),
        new StatusPair('LI', '417'),
        new StatusPair('LT', '370'),
        new StatusPair('LU', '352'),
        new StatusPair('MO', '853'),
        new StatusPair('MK', '389'),
        new StatusPair('MG', '261'),
        new StatusPair('MW', '265'),
        new StatusPair('MY', '60'),
        new StatusPair('MV', '960'),
        new StatusPair('ML', '223'),
        new StatusPair('MT', '356'),
        new StatusPair('MH', '692'),
        new StatusPair('MQ', '596'),
        new StatusPair('MR', '222'),
        new StatusPair('YT', '269'),
        new StatusPair('MX', '52'),
        new StatusPair('FM', '691'),
        new StatusPair('MD', '373'),
        new StatusPair('MC', '377'),
        new StatusPair('MN', '976'),
        new StatusPair('MS', '1664'),
        new StatusPair('MA', '212'),
        new StatusPair('MZ', '258'),
        new StatusPair('MN', '95'),
        new StatusPair('NA', '264'),
        new StatusPair('NR', '674'),
        new StatusPair('NP', '977'),
        new StatusPair('NL', '31'),
        new StatusPair('NC', '687'),
        new StatusPair('NZ', '64'),
        new StatusPair('NI', '505'),
        new StatusPair('NE', '227'),
        new StatusPair('NG', '234'),
        new StatusPair('NU', '683'),
        new StatusPair('NF', '672'),
        new StatusPair('NP', '670'),
        new StatusPair('NO', '47'),
        new StatusPair('OM', '968'),
        new StatusPair('PW', '680'),
        new StatusPair('PA', '507'),
        new StatusPair('PG', '675'),
        new StatusPair('PY', '595'),
        new StatusPair('PE', '51'),
        new StatusPair('PH', '63'),
        new StatusPair('PL', '48'),
        new StatusPair('PT', '351'),
        new StatusPair('PR', '1787'),
        new StatusPair('QA', '974'),
        new StatusPair('RE', '262'),
        new StatusPair('RO', '40'),
        new StatusPair('RU', '7'),
        new StatusPair('RW', '250'),
        new StatusPair('SM', '378'),
        new StatusPair('ST', '239'),
        new StatusPair('SA', '966'),
        new StatusPair('SN', '221'),
        new StatusPair('CS', '381'),
        new StatusPair('SC', '248'),
        new StatusPair('SL', '232'),
        new StatusPair('SG', '65'),
        new StatusPair('SK', '421'),
        new StatusPair('SI', '386'),
        new StatusPair('SB', '677'),
        new StatusPair('SO', '252'),
        new StatusPair('ZA', '27'),
        new StatusPair('ES', '34'),
        new StatusPair('LK', '94'),
        new StatusPair('SH', '290'),
        new StatusPair('KN', '1869'),
        new StatusPair('SC', '1758'),
        new StatusPair('SD', '249'),
        new StatusPair('SR', '597'),
        new StatusPair('SZ', '268'),
        new StatusPair('SE', '46'),
        new StatusPair('CH', '41'),
        new StatusPair('SI', '963'),
        new StatusPair('TW', '886'),
        new StatusPair('TJ', '7'),
        new StatusPair('TH', '66'),
        new StatusPair('TG', '228'),
        new StatusPair('TO', '676'),
        new StatusPair('TT', '1868'),
        new StatusPair('TN', '216'),
        new StatusPair('TR', '90'),
        new StatusPair('TM', '7'),
        new StatusPair('TM', '993'),
        new StatusPair('TC', '1649'),
        new StatusPair('TV', '688'),
        new StatusPair('UG', '256'),
        new StatusPair('GB', '44'),
        new StatusPair('UA', '380'),
        new StatusPair('AE', '971'),
        new StatusPair('UY', '598'),
        new StatusPair('US', '1'),
        new StatusPair('UZ', '7'),
        new StatusPair('VU', '678'),
        new StatusPair('VA', '379'),
        new StatusPair('VE', '58'),
        new StatusPair('VN', '84'),
        new StatusPair('VG', '1284'),
        new StatusPair('VI', '1340'),
        new StatusPair('WF', '681'),
        new StatusPair('YE', '969'),
        new StatusPair('YE', '967'),
        new StatusPair('ZM', '260'),
        new StatusPair('ZW', '263')
    ];

    public getCodes(): Array<StatusPair> {
        this.codes = this.codes.sort((a, b) => (a.statusName > b.statusName) ? 1 : -1);
        return this.codes;
    }
}